import { useContext, useEffect, useLayoutEffect } from 'react';
import { MobileContext, PerspectiveContext } from '../../Context';
import { DuperbrowseStreamContext } from '../DuperbrowseStreamContextProvider/DuperbrowseStreamContext';
import { scrollIntoViewInViewportCenter } from '../../utils/scrollIntoViewWithHeader';
// useLayoutEffect has a spammy warning in SSR about it having no effect there,
// which is dumb because neither useEffect nor useLayoutEffect is supposed
// to do anything in SSR. So to make the warning shut up, we just use
// useEffect in SSR while keep useLayoutEffect in browser; the end result
// should make zero difference because as mentioned, both are noop in SSR
var useLayoutEffectWithoutSSRComplaining = typeof window === 'undefined' ||
    process.env.NODE_ENV === 'test' ||
    global['isTestEnvironment']
    ? useEffect
    : useLayoutEffect;
function useDuperbrowseScrollRestoration(itemIds, ref, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    var _a = useContext(DuperbrowseStreamContext), stream = _a.stream, lastViewedItem = _a.lastViewedItem;
    var isMobile = useContext(MobileContext);
    var getScrollableContainer = useContext(PerspectiveContext).getScrollableContainer;
    var wasLastItemOpened = !!lastViewedItem && // if we have a just-closed stream
        lastViewedItem.streamId === stream.streamId && // and it's our current stream
        itemIds.includes(lastViewedItem.itemId); // and its last viewed item was this one
    useLayoutEffectWithoutSSRComplaining(function () {
        // then restore scroll position to ourselves
        if (isEnabled && wasLastItemOpened && ref.current) {
            scrollIntoViewInViewportCenter(ref.current, isMobile, getScrollableContainer() || undefined);
        }
    }, [wasLastItemOpened, isMobile, isEnabled]);
}
export default useDuperbrowseScrollRestoration;
//# sourceMappingURL=useDuperbrowseScrollRestoration.js.map